<template>
    <v-container grid-list-xs fluid>
        <v-toolbar color="primary" dense>
            <v-btn dark text @click="toggle = !toggle"
                ><v-icon>mdi-file-arrow-left-right</v-icon> Change</v-btn
            >
            <v-spacer></v-spacer>
            <v-toolbar-title class="white--text"
                >{{ toggle == true ? 'OO' : 'Contractor' }} Payroll Report by
                Period</v-toolbar-title
            >
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-container grid-list-xs>
            <v-row class="justify-center" v-show="select">
                <v-col cols="6">
                    <v-combobox
                        v-model="period"
                        :items="periods"
                        :item-text="'Period'"
                        auto-select-first
                        label="Select a Period"
                        hide-details
                        dense
                        :prepend-icon="'mdi-refresh'"
                        :append-outer-icon="'mdi-swap-horizontal'"
                        @change="printTypeReport"
                        @click:prepend="printTypeReport"
                        prepend-inner-icon="mdi-delete-circle"
                        @click:prepend-inner="dltPeriod"
                        @click:append-outer="select = !select"
                    ></v-combobox>
                </v-col>
            </v-row>
            <v-row class="justify-center" v-show="!select">
                <v-col cols="3">
                    <v-text-field
                        label="Start Date"
                        placeholder="yyyy-mm-dd"
                        v-mask="'####/##/##'"
                        :rules="dateRules"
                        required
                        type="tel"
                        id="StartDate"
                        :value="StartDate"
                        hide-details
                        dense
                    ></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                        label="End Date"
                        placeholder="yyyy-mm-dd"
                        v-mask="'####/##/##'"
                        :rules="dateRules"
                        type="tel"
                        id="EndDate"
                        :value="EndDate"
                        :append-outer-icon="'mdi-swap-horizontal'"
                        @click:append-outer="select = !select"
                        hide-details
                        dense
                    ></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-btn
                        color="primary"
                        v-if="toggle"
                        class="my-auto float-left"
                        small
                        @click="reportMultiPeriods()"
                        >View</v-btn
                    >
                    <v-btn
                        color="primary"
                        class="my-auto float-right"
                        small
                        @click="searchPeriod"
                        >Create</v-btn
                    >
                    <v-checkbox
                        label="Parking Period"
                        v-if="toggle"
                        class="my-auto float-right mr-6"
                        v-model="start"
                        :value="start"
                    ></v-checkbox>
                </v-col>
            </v-row>
        </v-container>
        <div v-if="toggle">
            <v-container grid-list-xs fluid>
                <v-data-table
                    dense
                    :headers="headers"
                    :search="search"
                    :items="filteredOO"
                    class="elevation-1"
                    fixed-header
                    height="650px"
                >
                    <template v-slot:top>
                        <v-row>
                            <v-col cols="4">
                                <v-text-field
                                    v-model="search"
                                    label="Search"
                                    append-icon="mdi-magnify"
                                    dense
                                >
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-btn
                                    color="success"
                                    class="ml-8"
                                    small
                                    text
                                    v-if="select"
                                    @click="reportDownload"
                                    ><v-icon>mdi-microsoft-excel</v-icon>
                                    Download</v-btn
                                >

                                <v-btn
                                    color="red"
                                    @click="dltExtras"
                                    dark
                                    small
                                    text
                                    v-if="select"
                                    class="ml-3"
                                    ><v-icon>mdi-delete</v-icon> Extras</v-btn
                                >

                                <v-btn
                                    color="secondary"
                                    @click="openAddTruckModal"
                                    dark
                                    small
                                    text
                                    v-if="select"
                                    class="ml-3"
                                    ><v-icon>mdi-truck</v-icon> Add Truck</v-btn
                                >
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item.Company="{ item }">
                        <v-combobox
                            v-model="item.Company"
                            :items="companys"
                            :item-text="'Company'"
                            :item-value="'CompanyId'"
                            auto-select-first
                            hide-details
                            dense
                            @change="expensesComments(item, 2)"
                            v-if="showAdd"
                        ></v-combobox>
                        <p v-else>
                            {{ item.Company }}
                        </p>
                    </template>

                    <template v-slot:item.OrderTotal="{ item }">
                        <td
                            v-if="
                                item.Type == 'Fuel' ||
                                    item.Type == 'Regular' ||
                                    item.Type == 'Demurrage'
                            "
                        >
                            {{ item.OrderTotal }}
                        </td>
                        <v-text-field
                            v-else
                            v-model="item.OrderTotal"
                            @change="saveParking(item)"
                            :disabled="!showAdd"
                            dense
                            hide-details
                        ></v-text-field>
                    </template>
                    <template v-slot:item.PeriodComment="{ item }">
                        <v-text-field
                            textarea
                            v-model="item.PeriodComment"
                            @change="saveCommets(item)"
                            v-if="showAdd"
                            :disabled="!showAdd"
                            dense
                            hide-details
                        ></v-text-field>
                        <td v-else>{{ item.PeriodComment }}</td>
                    </template>
                    <template v-slot:item.Action="{ item }" v-if="showAdd">
                        <v-btn
                            v-if="item.Crt"
                            color="primary"
                            icon
                            @click="createExt(item)"
                            ><v-icon>mdi-format-list-group-plus</v-icon></v-btn
                        >
                        <v-btn
                            v-if="
                                item.Type == 'Regular' ||
                                    item.Type == 'Fuel' ||
                                    item.Type == 'Demurrage' ||
                                    item.STMT === null
                            "
                            color="primary"
                            icon
                            @click="addExtExpnese(item)"
                            ><v-icon>mdi-plus</v-icon></v-btn
                        >
                        <v-btn
                            v-if="
                                item.Type == 'Regular' ||
                                    item.Type == 'Fuel' ||
                                    item.Type == 'Demurrage'
                            "
                            color="indigo"
                            icon
                            @click="dltStmtConfirm(item)"
                            ><v-icon>mdi-page-next</v-icon></v-btn
                        >
                        <v-btn
                            v-else
                            color="red"
                            icon
                            @click="dltTrnsConfirm(item)"
                            ><v-icon>mdi-delete</v-icon></v-btn
                        >
                    </template>

                    <template slot="body.append">
                        <tr>
                            <td colspan="9" class="text-right">Totals</td>
                            <td
                                width="5%"
                                class="font-weight-bold text-right pr-12"
                                style="font-size:14px;"
                            >
                                {{
                                    sumColumn(filteredOO, 'OrderTotal').toFixed(
                                        2
                                    )
                                }}
                            </td>
                            <td
                                width="5%"
                                class="font-weight-bold text-right pr-12"
                                style="font-size:14px;"
                            >
                                {{ sumColumn(filteredOO, 'HST').toFixed(2) }}
                            </td>
                            <td
                                width="5%"
                                class="font-weight-bold text-right pr-12"
                                style="font-size:14px;"
                            >
                                {{ sumColumn(filteredOO, 'Total').toFixed(2) }}
                            </td>
                            <td
                                width="5%"
                                class="font-weight-bold text-right pr-12"
                                style="font-size:14px;"
                            >
                                {{
                                    sumColumn(filteredOO, 'SubTotal').toFixed(2)
                                }}
                            </td>
                            <td
                                width="5%"
                                class="font-weight-bold text-right pr-12"
                                style="font-size:14px;"
                            >
                                {{
                                    sumColumn(filteredOO, 'ToBePaid').toFixed(2)
                                }}
                            </td>
                            <td colspan="2" width="20%"></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-container>
        </div>
        <div v-else>
            <v-data-table
                :headers="headersContractor"
                :items="filteredContract"
                :search="search"
                dense
                hide-details
                    fixed-header
                    height="650px"
            >
                <template v-slot:top>
                    <v-row>
                        <v-col cols="4">
                            <v-text-field
                                v-model="search"
                                label="Search"
                                append-icon="mdi-magnify"
                                dense
                            >
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <v-btn
                                color="success"
                                class="ml-8"
                                small
                                text
                                v-if="select"
                                @click="reportDownload"
                                ><v-icon>mdi-microsoft-excel</v-icon
                                >Download</v-btn
                            >

                            <v-btn
                                color="red"
                                @click="dltExtras"
                                dark
                                small
                                text
                                v-if="select"
                                class="ml-3"
                                ><v-icon>mdi-delete</v-icon> Extras</v-btn
                            >
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:item.PeriodComment="{ item }">
                    <v-text-field
                        textarea
                        v-model="item.PeriodComment"
                        @change="saveCommets(item)"
                        v-if="item.Type == 'Other'"
                        :disabled="!showAdd"
                        dense
                        hide-details
                    ></v-text-field>
                    <td v-else>{{ item.PeriodComment }}</td>
                </template>
                <template v-slot:item.Action="{ item }">
                    <v-btn
                        color="primary"
                        v-if="item.Type == 'Invoice'"
                        icon
                        @click="addExtExpnese(item)"
                        ><v-icon>mdi-plus</v-icon></v-btn
                    >
                    <v-btn
                        color="red"
                        v-if="item.Type == 'Other'"
                        icon
                        @click="dltTrnsConfirm(item)"
                        ><v-icon>mdi-delete</v-icon></v-btn
                    >
                    <v-btn
                        v-if="item.Type == 'Invoice'"
                        color="indigo"
                        icon
                        @click="dltInvoiceConfirm(item)"
                        ><v-icon>mdi-page-next</v-icon></v-btn
                    >
                </template>
                <template slot="body.append">
                    <tr>
                        <td colspan="6" class="text-right">Totals</td>
                        <td
                            width="5%"
                            class="font-weight-bold text-right pr-12"
                            style="font-size:14px;"
                        >
                            {{
                                sumColumn(filteredContract, 'Amount').toFixed(2)
                            }}
                        </td>
                        <td
                            width="5%"
                            class="font-weight-bold text-right pr-12"
                            style="font-size:14px;"
                        >
                            {{ sumColumn(filteredContract, 'HST').toFixed(2) }}
                        </td>
                        <td
                            width="5%"
                            class="font-weight-bold text-right pr-12"
                            style="font-size:14px;"
                        >
                            {{
                                sumColumn(filteredContract, 'Total').toFixed(2)
                            }}
                        </td>
                        <td
                            width="5%"
                            class="font-weight-bold text-right pr-12"
                            style="font-size:14px;"
                        >
                            {{
                                sumColumn(filteredContract, 'SubTotal').toFixed(
                                    2
                                )
                            }}
                        </td>
                        <td
                            width="5%"
                            class="font-weight-bold text-right pr-12"
                            style="font-size:14px;"
                        >
                            {{
                                sumColumn(filteredContract, 'ToBePaid').toFixed(
                                    2
                                )
                            }}
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </div>
        <ext
            v-if="$store.state.accounting.addExtExpense"
            @close="recallData"
            :expense="expense"
            :select="select"
            :toggle="toggle"
            :period="period"
        ></ext>

        <add_truck
            v-if="openAddTruck"
            @close="openAddTruck = false"
            :openAddTruck="openAddTruck"
            :trucks="trucks"
            :period="period"
            @recall="printTypeReport"
        ></add_truck>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </v-container>
</template>
<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
import ext from './../Modals/Accounting/AddExtExpense.vue';
import ConfirmDialogue from './../Modals/ConfirmDialogue.vue';
import add_truck from './../Modals/Accounting/AddTruck.vue';
import moment from 'moment';
export default {
    directives: { mask },
    components: {
        ext,
        ConfirmDialogue,
        add_truck
    },
    data: function() {
        return {
            valid: true,
            toggle: true,
            start: false,
            companys: null,
            period: null,
            periods: [],
            paydate: '',
            select: true,
            StartDate: null,
            EndDate: null,
            showAdd: true,
            crtperiod: false,
            unique: null,
            truck: null,
            trucks: [],
            expense: null,
            search: '',
            preview: [],
            openAddTruck: false,
            contractorData: [],
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ],
            headers: [
                { text: 'Company', value: 'Company', width: '10%' },
                { text: 'Truck', value: 'Truck', width: '3%' },
                { text: 'RentalTruck', value: 'RentalTruck', width: '3%' },
                { text: 'Type', value: 'Type', width: '3%' },
                { text: 'Specification', value: 'Specification', width: '10%' },
                { text: 'STMT', value: 'STMT', width: '3%' },
                { text: 'Reference', value: 'Reference', width: '5%' },
                { text: 'ClassName', value: 'ClassName', width: '10%' },
                { text: 'Date', value: 'Date', width: '10%' },
                { text: 'OrderTotal', value: 'OrderTotal', width: '5%' },
                { text: 'HST', value: 'HST', width: '5%' },
                { text: 'Total', value: 'Total', width: '5%' },
                { text: 'SubTotal', value: 'SubTotal', width: '5%' },
                { text: 'To be Paid', value: 'ToBePaid', width: '5%' },
                { text: 'Comments', value: 'PeriodComment', width: '15%' },
                { text: 'Action', value: 'Action', width: '8%' }
            ],
            headersContractor: [
                { text: 'Company', value: 'Company', width: '10%' },
                { text: 'Driver', value: 'Driver' },
                { text: 'PayDate', value: 'Date' },
                { text: 'PayId', value: 'STMT' },
                { text: 'Type', value: 'Type' },
                { text: 'Specification', value: 'Specification', width: '10%' },
                { text: 'Amount', value: 'Amount' },
                { text: 'HST', value: 'HST' },
                { text: 'QST', value: 'QST' },
                { text: 'Total', value: 'Total' },
                { text: 'SubTotal', value: 'SubTotal', width: '5%' },
                { text: 'To be Paid', value: 'ToBePaid', width: '5%' },
                { text: 'Comments', value: 'PeriodComment', width: '15%' },
                { text: 'Action', value: 'Action', width: '5%' }
                // { text: 'MaxTotal', value: 'MaxTotal' },
            ]
        };
    },
    watch: {
        select: function() {
            this.preview = [];
            this.contractorData = [];
            this.period = null;
        },
        toggle: function() {
            this.preview = [];
            this.contractorData = [];
            this.period = null;
        }
    },

    computed: {
        // filteredOO: function () {
        //     return this.preview.filter(i => {
        //         return !this.company || i.Company == this.company;
        //     });
        // },
        filteredOO() {
            const query = this.search.toLowerCase();
            return this.preview.filter(item => {
                for (const header of this.headers) {
                    const value = item[header.value];
                    if (
                        value &&
                        value
                            .toString()
                            .toLowerCase()
                            .includes(query)
                    ) {
                        return true;
                    }
                }
                return false;
            });
        },
        filteredContract() {
            const query = this.search.toLowerCase();
            return this.contractorData.filter(item => {
                for (const header of this.headersContractor) {
                    const value = item[header.value];
                    if (
                        value &&
                        value
                            .toString()
                            .toLowerCase()
                            .includes(query)
                    ) {
                        return true;
                    }
                }
                return false;
            });
        }
    },
    mounted() {
        this.LoadPeriods();
        this.LoadCompanys();
        this.loadTrucks();
    },

    methods: {
        sumColumn(items, key) {
            return items.reduce(
                (acc, item) => acc + parseFloat(item[key]) || 0,
                0
            );
        },
        reportDownload: async function(vl) {
            var str = this.$store;
            str.state.isLoading = true;
            if (this.toggle) {
                var inf = await this.preview.map(x => {
                    const obj = {
                        Company: x.Company,
                        Truck: x.Truck,
                        RentalTruck: x.RentalTruck,
                        Type: x.Type,
                        Specification: x.Specification,
                        STMT: x.STMT,
                        Reference: x.Reference,
                        ClassName: x.ClassName,
                        Date: x.Date,
                        OrderTotal: x.OrderTotal,
                        HST: x.HST,
                        Total: x.Total,
                        SubTotal: x.SubTotal,
                        ToBePaid: x.ToBePaid,
                        Comments: x.PeriodComment
                    };
                    return obj;
                });
            } else {
                var inf = await this.contractorData.map(x => {
                    const obj = {
                        Company: x.Company,
                        Driver: x.Driver,
                        Date: x.Date,
                        Type: x.Type,
                        Specification: x.Specification,
                        STMT: x.STMT,
                        Date: x.Date,
                        Amount: x.Amount,
                        HST: x.HST,
                        QST: x.QST,
                        Total: x.Total,
                        SubTotal: x.SubTotal,
                        ToBePaid: x.ToBePaid,
                        Comments: x.PeriodComment
                    };
                    return obj;
                });
            }

            var parms = {
                Filtered: inf
            };
            if (!vl) {
                parms.StartDate = this.$store.state.getMsk('StartDate');
                parms.EndDate = this.$store.state.getMsk('EndDate');
            } else {
                parms.StartDate = this.period['EfectiveDateStart'];
                parms.EndDate = this.period['EfectiveDateEnd'];
            }
            axios
                .post('/expenses/report/download', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        'Payroll Period ' +
                            this.$store.state.getMsk('StartDate') +
                            ' / ' +
                            this.$store.state.getMsk('EndDate') +
                            '.xlsx'
                    );
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        printTypeReport: function() {
            if (this.toggle) {
                this.report(true);
            } else {
                this.reportPeriods(true);
            }
        },
        report: function(vl) {
            var str = this.$store;
            str.state.isLoading = true;
            this.preview = [];
            var parms = {};
            this.showAdd = true;
            if (!vl) {
                parms.StartDate = this.$store.state.getMsk('StartDate');
                parms.EndDate = this.$store.state.getMsk('EndDate');
            } else {
                parms.StartDate = this.period['EfectiveDateStart'];
                parms.EndDate = this.period['EfectiveDateEnd'];
            }
            axios
                .post('expenses/report', parms)
                .then(response => {
                    this.preview = response.data;
                    const justStmt = response.data.map(x => {
                        return x.STMT;
                    });
                    const limt = this.eliminarDuplicados(justStmt);
                    limt.forEach(y => {
                        let incr = 0;
                        this.preview.forEach(async x => {
                            if (y == x.STMT) {
                                if (incr == 0) {
                                    x.Reference = x.STMT;
                                } else {
                                    if (x.STMT != null) {
                                        x.Reference = x.STMT + ' - ' + incr;
                                    }
                                }
                                incr++;
                            }
                        });
                    });
                    this.preview.forEach(async x => {
                        const alone = await this.preview.filter(objeto => {
                            return objeto.STMT == x.STMT;
                        });
                        if (alone.length > 1) {
                            console.log(alone.length);
                            x['Alone'] = false;
                        } else {
                            x['Alone'] = true;
                        }
                    });
                    console.log(this.preview);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        recallData: function() {
            if (this.toggle) {
                this.report(this.select);
            } else {
                this.reportPeriods(true);
            }
        },
        reportPeriods(vl) {
            var parms = {};
            var str = this.$store;
            str.state.isLoading = true;
            if (!vl) {
                parms.StartDate = this.$store.state.getMsk('StartDate');
                parms.EndDate = this.$store.state.getMsk('EndDate');
            } else {
                parms.StartDate = this.period['EfectiveDateStart'];
                parms.EndDate = this.period['EfectiveDateEnd'];
            }
            axios
                .post('ext-expenses/report/contractor', parms)
                .then(response => {
                    this.contractorData = response.data;
                })
                .catch(error => {
                    logErr(error);
                })
                .finally(() => {
                    str.state.isLoading = false;
                });
        },
        deletePeriod: function(all) {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {};
            parms.StartDate = this.period['EfectiveDateStart'];
            parms.EndDate = this.period['EfectiveDateEnd'];
            parms.ChargeType = this.toggle;
            parms.All = all;
            axios
                .post('fuel-expense/expenses/delete', parms)
                .then(response => {
                    console.log(response.data);

                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text:
                            'The extra charges have been successfully eliminated.'
                    });
                    location.reload();
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        loadTrucks: function() {
            this.$store.state.isLoading = true;
            axios
                .get('truck/active')
                .then(response => {
                    console.log(response.data);
                    this.trucks = response.data;
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
        },
        addExtExpnese: function(itm) {
            this.expense = itm;
            this.$store.state.accounting.addExtExpense = true;
        },
        LoadPeriods: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('ext-expense/get/periods')
                .then(response => {
                    this.periods = response.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        LoadCompanys: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('truck/companys')
                .then(response => {
                    this.companys = response.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        async dltExtras() {
            let about;
            if (this.toggle) {
                about =
                    'You are about to eliminate the extra charges for this period for Owner Operator.';
            } else {
                about =
                    'You are about to eliminate the extra charges for this period for Contractors.';
            }
            const ok = await this.$refs.confirmDialogue.show({
                title: about,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deletePeriod(false);
            }
        },
        async dltPeriod() {
            const ok = await this.$refs.confirmDialogue.show({
                title:
                    'You are about to eliminate the period of this action will eliminate all extra charges.',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deletePeriod(true);
            }
        },
        async dltTrnsConfirm(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete this extra expense',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deleteExtExpense(itm);
            }
        },
        async dltStmtConfirm(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title:
                    'You are about to delete this Statement for this period, this Statement will be added to the next period.',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                // console.log('Delete',itm);
                this.expensesDelete(itm);
                // this.deleteExtExpense(itm);
            }
        },
        async dltInvoiceConfirm(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title:
                    'You are about to delete this Invoice for this period, this Invoice will be added to the next period.',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                // console.log('Delete',itm);
                this.nextDriverInvoice(itm);
                // this.deleteExtExpense(itm);
            }
        },
        deleteExtExpense: function(itm) {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .delete('ext-expense/' + itm.ExtID)
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Extra Expenses deleted'
                    });
                    if (this.toggle) {
                        var idx = this.preview.findIndex(x => {
                            return x.ExtID == itm.ExtID;
                        });
                        this.preview.splice(idx, 1);
                    } else {
                        var idx = this.contractorData.findIndex(x => {
                            return x.ExtID == itm.ExtID;
                        });
                        this.contractorData.splice(idx, 1);
                    }
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        saveCommets: function(itm) {
            if (itm.Type == 'Demurrage' || itm.Type == 'Regular') {
                this.expensesComments(itm, 1);
            } else if (itm.Type == 'Fuel') {
                this.fuelComments(itm);
            } else {
                console.log('Comment Extra');
                this.extExpensesComments(itm, 1);
            }
        },
        eliminarDuplicados: function(arr) {
            const uniqueElements = new Set();
            return arr.filter(item => {
                const serializedItem = JSON.stringify(item);
                if (!uniqueElements.has(serializedItem)) {
                    uniqueElements.add(serializedItem);
                    return true;
                }
                return false;
            });
        },
        createPeriod: async function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                Start: this.start,
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                ChargeType: this.toggle
            };
            str.state.isLoading = true;
            await axios
                .post('ext-expenses/create/period', parms)
                .then(response => {
                    console.log(response.data);

                    if (!this.toggle) {
                        this.LoadPeriods();
                        this.contractorData = response.data;
                    } else {
                        this.LoadPeriods();
                        this.report(false);
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Period Saved'
                        });
                    }
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        expensesComments: function(itm, atv) {
            var str = this.$store;
            var parms = {
                PeriodComment: itm.PeriodComment
            };
            if (atv == 2) {
                parms.CompanyTruckPeriod = itm.Company.CompanyId;
                parms.StartDate = this.period['EfectiveDateStart'];
                parms.EndDate = this.period['EfectiveDateEnd'];
            }

            str.state.isLoading = true;
            axios
                .put('ext-expense/update-company/' + itm.STMT, parms)
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Saved'
                    });
                    this.report(true);
                    if (atv == 2) {
                        this.report(true);
                        // if(itm.Type == 'Regular' || itm.Type == 'Demurrage'){
                        //     const cpnIdx = this.preview.findIndex(x => {
                        //         return x.Type == 'Fuel' && x.STMT == itm.STMT;
                        //     });

                        //     if(cpnIdx >= 0){
                        //         this.preview[cpnIdx].Company = itm.Company.Company;
                        //     }
                        // }else{
                        //     const cpnIdx = this.preview.findIndex(x => {
                        //         return x.Type == 'Regular' && x.STMT == itm.STMT || x.Type == 'Demurrage' && x.STMT == itm.STMT;
                        //     });
                        //     if(cpnIdx >= 0){
                        //         this.preview[cpnIdx].Company = itm.Company.Company;
                        //     }
                        // }
                    }
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        extExpensesComments: function(itm) {
            var str = this.$store;
            var parms = {
                PeriodComment: itm.PeriodComment
            };
            str.state.isLoading = true;
            axios
                .put('ext-expense/' + itm.ExtID, parms)
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Comment Saved'
                    });
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        fuelComments: function(itm) {
            var str = this.$store;
            var parms = {
                PeriodComment: itm.PeriodComment,
                STMT: Number(itm.STMT),
                Truck: itm.TruckID
            };
            str.state.isLoading = true;
            axios
                .post('expenses/report/comment', parms)
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Comment Saved'
                    });
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        searchPeriod: function() {
            var str = this.$store;
            this.crtperiod = false;
            this.showAdd = true;
            str.state.isLoading = true;
            var parms = {};
            parms.StartDate = this.$store.state.getMsk('StartDate');
            parms.EndDate = this.$store.state.getMsk('EndDate');
            parms.ChargeType = this.toggle;
            axios
                .post('expenses/check/dates', parms)
                .then(response => {
                    if (response.data == 1) {
                        str.dispatch('setSnackbar', {
                            color: 'primary',
                            text:
                                'You have selected a date range in which 1 or more periods have been assigned.'
                        });
                    } else {
                        this.createPeriod();
                        this.crtperiod = true;
                    }
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        reportMultiPeriods() {
            var str = this.$store;
            str.state.isLoading = true;
            this.preview = [];
            var parms = {};
            parms.StartDate = this.$store.state.getMsk('StartDate');
            parms.EndDate = this.$store.state.getMsk('EndDate');
            parms.ChargeType = this.toggle;

            axios
                .post('expenses/report/multi/periods', parms)
                .then(response => {
                    this.preview = response.data;
                    this.showAdd = false;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        expensesDelete: function(itm) {
            var str = this.$store;
            var parms = {
                DateNextPeriod: moment(this.period['EfectiveDateEnd'])
                    .add(1, 'days')
                    .format('YYYY-MM-DD')
            };
            console.log(parms);
            str.state.isLoading = true;
            axios
                .put('payroll/' + itm.STMT, parms)
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Statement Deleted'
                    });
                    this.report(true);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        nextDriverInvoice: function(itm) {
            var str = this.$store;
            var parms = {
                DateNextPeriod: moment(this.period['EfectiveDateEnd'])
                    .add(1, 'days')
                    .format('YYYY-MM-DD')
            };
            console.log(parms);
            str.state.isLoading = true;
            axios
                .put('driver-invoice/' + itm.STMT, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Change saved successfully'
                    });
                    this.report(true);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        saveParking: function(itm) {
            var str = this.$store;
            if (itm.HST > 0 || itm.HST < 0) {
                itm.HST = Number(itm.OrderTotal * 0.13).toFixed(2);
                itm.Total =
                    Number(itm.OrderTotal * 0.13) + Number(itm.OrderTotal);
                itm.Total = Number(itm.Total).toFixed(2);
            } else {
                itm.Total = itm.OrderTotal;
            }
            var parms = {
                HST: itm.HST,
                Amount: itm.OrderTotal,
                Total: itm.Total
            };
            str.state.isLoading = true;
            axios
                .put('ext-expense/' + itm.ExtID, parms)
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Extra Expenses deleted'
                    });
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        openAddTruckModal: function() {
            var str = this.$store;
            if (this.period === null) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Select a period'
                });
            } else {
                this.openAddTruck = true;
            }
        },
        createExt: function(itm) {
            var str = this.$store;
            var parms = {
                CompanyId: itm.CompanyId,
                StartDate: this.period['EfectiveDateStart'],
                EndDate: this.period['EfectiveDateEnd'],
                Truck: itm.TruckID,
                STMT: itm.STMT,
                PayDate: itm.PayDate
            };

            str.state.isLoading = true;
            axios
                .post('ext-expense/create-by-alone', parms)
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Extra expenses created'
                    });
                    this.report(true);

                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'This truck in this company already has extra expenses'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
